import { finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: Http) { }
  postData(apiUrl: any, data: any, access_token: any) {
    let headers = new Headers({ "Content-Type": "application/json"});
  //  headers.append('Access-Control-Allow-Origin', '*');
    let options = new RequestOptions({ headers: headers });
    return this.http.post(apiUrl, data, options).pipe(finalize(() => { }));
    // .finally(() => {
    // });
  }

  getUserData(apiUrl: any, data: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(apiUrl, data, options);
    // .finally(() => {
    // });
  }
  putData(apiUrl: any, data: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.put(apiUrl, data, options).pipe(finalize(() => { }));
  }
  deleteData(apiUrl: any, data: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(apiUrl, data).pipe(finalize(() => { }));
  }
  GetData(apiUrl: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(apiUrl).pipe(finalize(() => { }));
  }
  GetDataByID(apiUrl: any, data: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(apiUrl, data).pipe(finalize(() => { }));
  }
  GetAllTransactionDetails(apiUrl: any, data: any) {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(apiUrl, data).pipe(finalize(() => { }));
  }
  private getHeaders() {
    // I included these headers because otherwise FireFox
    // will request text/html instead of application/json
    let headers = new Headers();
    headers.append("Accept", "application/json");
    return headers;
  }
}
